import React, { useState, useEffect } from "react";
import { getIcons, userRole } from "../../components/Constant/Constant";
import { useNavigate } from "react-router-dom";
import { propertySaleTypes } from "../../Enum";

const PropertiesSelectingModel = ({ isOpen, close, onSelect, accessType , mapData}) => {
  const icons = getIcons();
  const navigate = useNavigate();

  const PropertyType = [
    { label: "Layout", icon: icons.LayoutIcon, id: "fOQZ4CPJQYZikZnFkrxy" },
    {
      label: "Resale Plot",
      icon: icons.ResalePlotIcon,
      id: "ZfO3nhrBLCS2aNhTcO5p",
    },
    { label: "Villa", icon: icons.villaIcon, id: "k6QfCzo0QVXutC3MUTfV" },
    {
      label: "Apartment",
      icon: icons.ApartmentIcon,
      id: "xOl7nFLzvXtqVAcSrvIC",
    },
    {
      label: "Acres and Cents",
      icon: icons.AcresCentsIcon,
      id: "w0DLyAzJGYDl5Gr8jCbr",
    },
  ];

  const [selectedSaleType, setSelectedSaleType] = useState("");
  const [selectedSaleName, setSelectedSaleName] = useState("");

  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [selectedPropertyDetails, setSelectedPropertyDetails] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedSaleType("");
      setSelectedPropertyType("");
    }
  }, [isOpen]);

  const handlePropertyType = (item) => {
    setSelectedPropertyType(item.id);
    setSelectedPropertyDetails(item);
  };

  const handleSubmit = () => {
    if (!selectedSaleType || !selectedPropertyDetails.label) return;

    const state = {
      selectedPropertyDetails,
      propertySaleType: selectedSaleType,
      selectedSaleName,
      mapData :mapData
    };
    if (accessType === "RoughDraft") {
      if (selectedPropertyDetails.label === "Layout") {
        navigate(`/procurement-raughDraft/property-info`, { state });
      } else if (selectedPropertyDetails.label === "Acres and Cents") {
        navigate(`/procurement-raughDraft/acres-and-cents`, { state });
      } else if (selectedPropertyDetails.label === "Resale Plot") {
        navigate(`/procurement-raughDraft/resale-plot`, { state });
      }
    } else if (accessType === "Prospect") {
      if (selectedPropertyDetails.label === "Layout") {
        navigate(`/prospect/layout`, { state });
      } else if (selectedPropertyDetails.label === "Acres and Cents") {
        navigate(`/prospect/acres-and-cents`, { state });
      } else if (selectedPropertyDetails.label === "Resale Plot") {
        navigate(`/prospect/resale-plot`, { state });
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300"
      onClick={(e) => e.target === e.currentTarget && close()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white flex flex-col gap-6 rounded-lg p-5 w-full max-w-2xl relative animate-fade-in-up">
        {/* Header */}
        <div className="flex items-center justify-between bg-slate-50 px-4 py-2 rounded-lg">
          <h2
            id="modal-title"
            className="text-lg font-semibold text-customGreen"
          >
            Create New Property
          </h2>
          <button
            onClick={close}
            className="hover:text-gray-500 border bg-white p-2 text-red-500 transition-colors rounded-full w-9 h-9 flex items-center justify-center"
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/XPath/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>

        {/* Sale Types */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">
            Select Sale Type
          </label>
          <div className="flex items-center gap-4">
            {propertySaleTypes.map((type) => (
              <label
                key={type.id}
                className={`flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer transition-all
      ${selectedSaleType === type.id ? "text-customGreen" : ""}`}
              >
                <input
                  type="radio"
                  name="saleType"
                  value={type.id}
                  checked={selectedSaleType === type.id}
                  onChange={() => {
                    setSelectedSaleType(type.id);
                    setSelectedSaleName(type.label);
                    setSelectedPropertyType("");
                  }}
                  className="hidden"
                />
                <div
                  className={`w-5 h-5 rounded-full border-2 flex items-center justify-center
        ${
          selectedSaleType === type.id
            ? "border-customGreen"
            : "border-slate-400"
        }`}
                >
                  {selectedSaleType === type.id && (
                    <div className="w-3 h-3 bg-customGreen rounded-full" />
                  )}
                </div>
                <span className="text-sm font-medium">{type.label}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Property Types */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">
            Select Property Type
          </label>
          <div className="grid grid-cols-1 gap-3 mt-4">
            {PropertyType.map((item, index) => (
              <button
                key={index}
                onClick={() => handlePropertyType(item)}
                className={`cursor-pointer rounded-full p-3 flex items-center gap-3 transition-all ${
                  selectedPropertyType === item.id
                    ? "border border-customGreen bg-green-50 shadow-sm"
                    : " bg-white hover:border-slate-400 hover:bg-slate-50"
                }`}
              >
                <div className="rounded-full p-2">
                  <img
                    src={item.icon}
                    alt={item.label}
                    className="w-7 h-7 object-contain"
                  />
                </div>
                <div className="font-medium">{item.label}</div>
              </button>
            ))}
          </div>
        </div>

        {/* Confirm Button */}
        <div className="flex justify-end ">
          <button
            onClick={handleSubmit}
            disabled={!selectedSaleType || !selectedPropertyType}
            className={`px-6 py-2 rounded-md font-semibold transition-all ${
              selectedSaleType && selectedPropertyType
                ? "bg-customGreen text-white hover:bg-green-700 shadow-md"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
          >
            Create Property
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertiesSelectingModel;
